module.exports = __webpack_public_path__ + "static/media/contact us.a8beb773.png";